import Vue from 'vue';
import Vuex from 'vuex';
import createModule from './modules/base';
import groups from '@/store/modules/groups.js';
import _ from 'lodash';
import { unwind } from '@jlaustill/unwind';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      userID: '',
      email: '',
      firstName: '',
      lastName: ''
    },
    /*userRoles: [],*/
    token: '',
    roles: [],
    userPermissions: [],
    questionFormats: [],
    transition: 'fade',
    headerPreferences: {}
  },
  mutations: {
    setUser(state, user) {
      state.user.userID = user.userID;
      state.user.email = user.email;
      state.user.firstName = user.firstName;
      state.user.lastName = user.lastName;
      //state.userRoles = user.roles;
      state.user.roles = user.roles;
    },
    setAuthToken(state, token) {
      state.token = token;
    },
    initApp(state, data) {
      state.roles = data.roles;
      state.userPermissions = data.permissions;
    },
    setQuestionFormats(state, formats) {
      state.questionFormats = formats;
    },
    changeTransition(state, transition) {
      state.transition = transition;
    },
    setPreference(state, { name, value }) {
      state.headerPreferences[name] = value;
      //console.log('saving preference', name, value);

      // localStorage.setItem(`preference:${name}`, value);
    }

    // setBackdrop(state) {
    //   state.fullBackdrop = true;
    // },
    // resetBackdrop(state) {
    //   state.fullBackdrop = false;
    // }
  },
  getters: {
    userOrganization: state => {
      return state.user.roles[0].organizationID;
    },
    userGroup: state => {
      return state.user.roles[0].groupID;
    },
    userRole: state => {
      if (state.user.roles.length > 0) return state.user.roles[0].name;
    },
    userRoleId: state => {
      //if (state.user.roles.length > 0) return state.user.roles[0].roleID;
      if (state.user.roles.length <= 1) {
        return state.user.roles[0].roleID;
      } else {
        let maxRole = 40;
        for (let i = 0; i < state.user.roles.length; i++) {
          if (state.user.roles[i].roleID < maxRole)
            maxRole = state.user.roles[i].roleID;
        }
        return maxRole;
      }
    },
    userFullnameAbrev: state => {
      if (state.user.firstName)
        return state.user.firstName + ' ' + state.user.lastName;
      else return '';
    },
    hasRoleInGroup: state => (importance, groupID) => {
      return _.chain(state.user.roles)
        .map(r => ({
          groupID: r.groupID,
          organizationID: r.organizationID,
          role: _.find(state.roles, { roleID: r.roleID })
        }))
        .some(r => r.groupID == groupID && r.role.importance >= importance)
        .value();
    },
    preferences: state => route => {
      return _.get(state.headerPreferences, route, null);
    }
  },
  modules: {
    permissions: createModule({ idField: 'permissionID' }),
    projects: createModule({ idField: 'projectID' }),
    organizations: createModule({ idField: 'organizationID' }),
    groups: groups,
    projectRequests: createModule({
      idField: 'formID',
      searchFields: [{ field: 'title' }]
    }),
    users: createModule({
      idField: 'userID',
      searchFields: [
        {
          field: 'name',
          extractor: item => `${item.firstName} ${item.lastName}`
        },
        { field: 'email' }
      ],
      getters: {
        unwindRoles: state => {
          return unwind(state._items, 'roles');
        },
        listByOrganization: state => {
          return _.groupBy(
            unwind(state._items, 'roles'),
            'roles.organizationID'
          );
        }
      }
    })
  }
});
